import { IS_MOBILE } from '@constants/global.js';
import { UIDiv } from '@ui';

/**
 * Skeleton loader for the project header
 * Shows placeholder UI while the header is loading
 * The width are trying to respect the actual component widths for consistency
 */
export default class ProjectHeaderSkeleton extends UIDiv {
  constructor() {
    super();
    this.setId('project-header-skeleton');
    this.setClass(
      'flex flex-wrap items-center gap-x-2.5 gap-y-2 md:gap-3 mb-4 relative md:pr-8 animate-pulse',
    );

    this.#render();
  }

  #render() {
    // Project type picker skeleton
    const typePickerSkeleton = new UIDiv();
    typePickerSkeleton.setClass(
      'h-10 w-[135px] md:w-[160px] bg-gray-200 rounded-lg',
    );
    this.add(typePickerSkeleton);

    // Vertical divider
    const divider = new UIDiv();
    divider.setClass('h-10 w-[1px] bg-gray-100');
    this.add(divider);

    // Add project button skeleton
    const addButtonSkeleton = new UIDiv();
    addButtonSkeleton.setClass(
      `h-10 ${IS_MOBILE() ? 'w-[42px]' : 'w-[125px]'} bg-gray-200 rounded-lg`,
    );
    this.add(addButtonSkeleton);

    // View mode selector skeleton
    const viewModeSkeleton = new UIDiv();
    viewModeSkeleton.setClass('h-10 w-[84px] bg-gray-200 rounded-lg');
    this.add(viewModeSkeleton);

    // Column filter skeleton
    const columnFilterSkeleton = new UIDiv();
    columnFilterSkeleton.setClass(
      `h-10 ${IS_MOBILE() ? 'w-[44px]' : 'w-[100px]'} bg-gray-200 rounded-lg`,
    );
    this.add(columnFilterSkeleton);

    // Data actions skeleton
    const dataActionsSkeleton = new UIDiv();
    dataActionsSkeleton.setClass(
      `h-10 ${IS_MOBILE() ? 'w-[44px]' : 'w-[115px]'} bg-gray-200 rounded-lg`,
    );
    this.add(dataActionsSkeleton);

    // Search input skeleton
    const searchSkeleton = new UIDiv();
    searchSkeleton.setClass(
      `h-10 ${IS_MOBILE() ? 'flex-grow' : 'w-48'} bg-gray-200 rounded-lg`,
    );
    this.add(searchSkeleton);
  }
}
